// components/ProtectedRoute.js

import React from "react";
import { Navigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { getToken } from "../services/authorize";
import { useAuth } from "../services/authProvider";

const ProtectedRoute = ({ component: Component, requiredPositions, ...rest }) => {
  const isAuthenticated = getToken();
  const { posIds, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">กำลังโหลด...</span>
        </Spinner>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/pages/signin" replace />;

  if (requiredPositions && !posIds.some(pos => requiredPositions.includes(pos))) {
    return <Navigate to="/not-found" replace />;
  }

  return <Component {...rest} />;
};

export default ProtectedRoute;